// translations
const i18n = Object.freeze({
  SHOW: 'Show',
  HIDE: 'Hide',
  DETAILS: 'details',
  SLIDE_LEFT_FOR_MORE: 'slide left for more'
});

export default i18n;
